'use client';

import { LoginLink } from "@kinde-oss/kinde-auth-nextjs/components";
import { Lock } from "lucide-react";
import { Button } from "../ui/button";
import Link from "next/link";

export default function LoginRedirect({ message = "to access this feature" }) {
  return (
    <div className="fixed top-0 left-0 w-screen h-screen inset-0 z-50 flex items-center justify-center 
        bg-white/60 dark:bg-gray-900/60 backdrop-blur-[2px] 
        border border-gray-200 dark:border-gray-700">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-2xl 
        border border-gray-100 dark:border-gray-700 text-center max-w-sm 
        transform transition-all animate-in fade-in zoom-in duration-300">
        <div className="mx-auto w-16 h-16 bg-indigo-100 dark:bg-indigo-900/30 rounded-full 
        flex items-center justify-center mb-4">
          <Lock className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
        </div>
        
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Login Required
        </h3>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Please sign in {message} and start using Carta AI’s professional tools.
        </p>
        
        <Link className="block w-full mb-4 bg-indigo-600 hover:bg-indigo-700 
            text-white font-semibold py-3 rounded-lg transition-colors shadow-lg 
            shadow-indigo-200 dark:shadow-none" 
            href="/auth/login">
            Login to existing account
        </Link>
        {/* <LoginLink className="block w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-lg transition-colors shadow-lg shadow-indigo-200 dark:shadow-none">
          Sign In / Register
        </LoginLink> */}
        <Link href="/auth/register" 
            className="underline text-indigo-600">
            Register a new account
        </Link>
      </div>
    </div>
  );
}